import React from "react";

const Btn = ({
  active,
  id,
  title,
  onAction,
  option,
  innerClass,
  bgColor,
  textColor,
  borderColor,
}) => {
  //action:ready, on, pressed, loading, option:bottom(아래 고정)

  return (
    <>
      <div
        className={
          "text-center " +
          (option === "bottom"
            ? "maxW fixed left-4 right-4 z-30 mx-auto "
            : " ") +
          innerClass
        }
        style={option === "bottom" ? {bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))'} : undefined}
      >
        {onAction ? (
          <button
            id={id ? id : null}
            onClick={active === "on" ? onAction : null}
            disabled={!active || active === "on" ? false : true}
            className={
              `w-full py-4 flex items-center justify-center ` +
              (option === "gpt"
                ? "rounded px-4 text-body1_500l "
                : "rounded-2xl leading-7 tracking-[0.24px] ") +
              (active === "on"
                ? `${bgColor} ${borderColor} ${textColor}`
                : active === "ready"
                ? bgColor === "bg-main"
                  ? ` bg-[#90B5FF] text-white `
                  : "" + borderColor === " border border-main"
                  ? ` border border-[#90B5FF] text-[#90B5FF]`
                  : "bg-[#939393] text-white"
                : active === "loading"
                ? `${bgColor} ${borderColor} ${textColor} cursor-wait`
                : "bg-green_100 active:bg-green_120")
            }
          >
            {active === "loading" ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading...
              </>
            ) : id !== "checkMealPlan"
              ? title
              : !active || active === "on"
              ? title
              : "Generating meal plan. Please wait!"}
          </button>
        ) : (
          <button
            type="submit"
            className={
              `w-full rounded-2xl py-4 text-body3_700 flex items-center justify-center ` +
              (active === "on"
                ? `${bgColor} ${borderColor} ${textColor}`
                : active === "ready"
                ? bgColor === "bg-main"
                  ? ` bg-[#90B5FF] text-white `
                  : "" + borderColor === " border border-main"
                  ? ` border border-[#90B5FF] text-[#90B5FF]`
                  : ""
                : active === "loading"
                ? `${bgColor} ${borderColor} ${textColor} cursor-wait`
                : "bg-green_100 active:bg-green_120")
            }
          >
            {active === "loading" ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading...
              </>
            ) : title}
          </button>
        )}
      </div>
    </>
  );
};

export default Btn;
